import { render, staticRenderFns } from "./pizzaSize.vue?vue&type=template&id=aa6cd70c&"
import script from "./pizzaSize.vue?vue&type=script&lang=js&"
export * from "./pizzaSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports